import { useRef, useState } from "react";
import { resizePhoto } from "../lib/image.js";

// One-tap odometer capture: camera → resize → upload+OCR → hands
// { photo_key, reading, confidence, ocr_error } to the caller. The reading is
// a suggestion; the form shows it editable before anything is saved.
export default function OdometerSnapButton({ label = "📷 Snap odometer", className = "", onRead }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function onPick(e) {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      const blob = await resizePhoto(file, 2048, 0.9); // digits need resolution, esp. dim night displays
      const form = new FormData();
      form.append("photo", blob, "odometer.jpg");
      const res = await fetch("/api/mileage/ocr", { method: "POST", body: form, credentials: "include" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Upload failed");
      onRead?.(data);
    } catch (err) {
      setError(err.message === "Failed to fetch" ? "No connection — try again with signal." : err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={onPick} />
      <button type="button" onClick={() => fileRef.current?.click()} disabled={busy} className={className}>
        {busy ? "Reading odometer…" : label}
      </button>
      {error && <p className="mt-1 text-center text-xs text-red-600">{error}</p>}
    </>
  );
}
